import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Modal,
    Stack,
    Typography,
    useMediaQuery
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { pricingPlanCardItems } from './pricing-constants';
import PricingCurrentPlanImage from 'assets/images/dashboard/pricing/currentPlan.svg';
import PricingDecor from 'assets/images/dashboard/pricing/pricing-decor.png';
import { useTheme } from '@emotion/react';
import { PLAN_TYPE } from 'helper/checkPlan.helper';
import UpdatePlanCardSkeleton from 'ui-component/cards/Skeleton/UpdatePlanSkeleton';
import PricingCardShareHolder from './PricingCardShareHolderWithFAQ/PricingCardShareHolder';
import { useEffect, useState } from 'react';
import ReactivateModal from './ReactivateModal';
import { useLocation } from 'react-router';

const UpdatePricingCardItem = ({
    planList,
    selectedPlan = '',
    loading,
    setSelectedPlans,
    onHandleClickUpdatePlan,
    selectedTier,
    isReactivate,
    onReactivatePlan
}) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [newSelectedPlan, setSelectedNewPlan] = useState('');
    const [newSelectedPriceId, setNewSelectedPriceId] = useState('');
    const userParsedData = localStorage?.getItem('diologUserData') ? JSON.parse(localStorage?.getItem('diologUserData')) : {};
    const sortPricingPlanCardItemsBySelectedItems = (itemFirst, itemSecond) => {
        if (itemFirst.heading === selectedPlan) {
            return -1; // item first comes before item second
        } else if (itemSecond.heading === selectedPlan) {
            return 1; // item second comes before item second
        } else {
            return 0; // maintain the order
        }
    };
    const newPricingPlanCardItem = pricingPlanCardItems.sort(sortPricingPlanCardItemsBySelectedItems);
    return (
        <>
            <Grid sx={{ mt: 2 }} container justifyContent="space-between" alignContent={'flex-start'} spacing={2}>
                <div className="decor-background">
                    <img src={PricingDecor} alt="pricing-decor" />
                </div>
                {planList.length ? (
                    newPricingPlanCardItem.map((planCardItem) => {
                        const planItem = planList.find((plan) => plan.name === planCardItem.heading);
                        const pricingCardItemForSelectionList = newPricingPlanCardItem[2];
                        return planCardItem.type !== 'shareholder' ? (
                            <Grid item key={planCardItem.id + 'updatePlanPricing'} xs={12}>
                                <Card className="update-card-wrapper">
                                    <Grid
                                        container
                                        flexDirection={'row'}
                                        justifyContent={'space-between'}
                                        alignContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        spacing={{ xs: 2, lg: 10 }}
                                    >
                                        <Grid item xs={12} md={5}>
                                            <CardHeader
                                                title={
                                                    <>
                                                        {selectedPlan === planCardItem.heading && (
                                                            <img
                                                                src={PricingCurrentPlanImage}
                                                                alt="pricing-current-plan"
                                                                style={{ marginBottom: '16px' }}
                                                            />
                                                        )}
                                                        <h2 className="small-heading">{planCardItem.haedingToShow}</h2>
                                                    </>
                                                }
                                            />
                                            <CardContent style={{ marginBottom: '16px' }}>
                                                <Typography variant="h1" component="span" className="title-heading text-dark-blue">
                                                    {selectedTier !== 'infinite' ? planCardItem.currency : ''}
                                                </Typography>
                                                <Typography variant="h1" component="span" className="title-heading text-dark-blue">
                                                    {planCardItem.heading === PLAN_TYPE.Freemium
                                                        ? planCardItem.amount
                                                        : planCardItem?.amount?.[selectedTier] || '5000'}
                                                </Typography>
                                                <Typography variant="p" component="span" className="tier-description">
                                                    {selectedTier === 'infinite' ? '' : '/'}
                                                    {planCardItem.heading === PLAN_TYPE.Freemium
                                                        ? planCardItem?.subDescription
                                                        : planCardItem?.subDescription?.[selectedTier] || '5000'}
                                                </Typography>
                                            </CardContent>
                                            <CardContent>
                                                <Typography variant="p" component={'p'} className="tier-description">
                                                    {planCardItem.subTitle}
                                                </Typography>
                                                {planCardItem.heading === PLAN_TYPE.Premium && (
                                                    <PricingCardShareHolder
                                                        defaultSelectValue={selectedTier}
                                                        handleChange={setSelectedPlans}
                                                        selectLists={pricingCardItemForSelectionList.menuListSelection.lists}
                                                        shareHolderDescription={''}
                                                        shareHolderTitle={pricingCardItemForSelectionList.updateHeadingToShow}
                                                        textAfterSelect={''}
                                                        isUpdate={true}
                                                        isCurrentSelectedPlan={selectedPlan}
                                                    />
                                                )}
                                                {selectedPlan !== planCardItem.heading && selectedTier !== 'infinite' && !isReactivate && (
                                                    <Button
                                                        className="pricing-button"
                                                        onClick={() => {
                                                            if (
                                                                planCardItem.heading === PLAN_TYPE.Premium &&
                                                                userParsedData.plan === PLAN_TYPE.Freemium
                                                            ) {
                                                                onHandleClickUpdatePlan(planItem.name, planItem?.default_price);
                                                            } else {
                                                                setNewSelectedPriceId(planItem?.default_price);
                                                                setSelectedNewPlan(planItem?.name);
                                                                handleOpen(true);
                                                            }
                                                        }}
                                                        disabled={loading}
                                                    >
                                                        {selectedPlan === PLAN_TYPE.Premium ? 'Downgrade' : 'Upgrade'}
                                                    </Button>
                                                )}
                                                {selectedPlan === planCardItem.heading && selectedTier !== 'infinite' && isReactivate && (
                                                    <Button
                                                        className="pricing-button"
                                                        onClick={() => {
                                                            onReactivatePlan();
                                                        }}
                                                        disabled={loading}
                                                    >
                                                        Reactivate
                                                    </Button>
                                                )}
                                                {selectedPlan !== planCardItem.heading && selectedTier === 'infinite' ? (
                                                    <Button
                                                        className="pricing-button"
                                                        disabled={loading}
                                                        onClick={() => window.open('https://www.diolog.com.au/contact', '_blank')}
                                                    >
                                                        Contact Sales
                                                    </Button>
                                                ) : null}

                                                {/* <Button className="pricing-button" onClick={handleOpen} sx={{ marginTop: '15px' }}>
                                                    Re-activate
                                                </Button> */}
                                            </CardContent>
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            md={7}
                                            className={`${planCardItem.heading === PLAN_TYPE.Freemium ? 'freemium-plan-card' : ''} ${
                                                PLAN_TYPE.Freemium === selectedPlan ? 'freemium-plan-card-tag' : ''
                                            } `}
                                        >
                                            {PLAN_TYPE.Freemium !== planCardItem.heading && planCardItem.textAfterButton && (
                                                <Typography variant="p" component={'p'} className="tier-description">
                                                    {planCardItem.textAfterButton || ' '}
                                                </Typography>
                                            )}
                                            <Grid container spacing={{ xs: 2, lg: 6 }} mt="0 !important">
                                                <Grid item xs={12} md={6} pt="0 !important">
                                                    <CardContent>
                                                        <List className="feature-lists">
                                                            {planCardItem.updateListItem.first.map((item) => {
                                                                return (
                                                                    <ListItem key={item.id}>
                                                                        <ListItemIcon>
                                                                            <CheckIcon sx={{ fill: '#fc7013' }} />
                                                                        </ListItemIcon>
                                                                        <ListItemText
                                                                            primary={
                                                                                <Typography variant="p" className="tier-description">
                                                                                    {item.text}
                                                                                </Typography>
                                                                            }
                                                                        />
                                                                    </ListItem>
                                                                );
                                                            })}
                                                        </List>
                                                    </CardContent>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    md={6}
                                                    pt="0 !important"
                                                    // sx={
                                                    //     planCardItem.textAfterButton
                                                    //         ? isMobile
                                                    //             ? {
                                                    //                   mt: -8
                                                    //               }
                                                    //             : {
                                                    //                   mt: 6
                                                    //               }
                                                    //         : isMobile
                                                    //         ? {
                                                    //               mt: -8
                                                    //           }
                                                    //         : {
                                                    //               mt: 0
                                                    //           }
                                                    // }
                                                >
                                                    <CardContent>
                                                        <List className="feature-lists">
                                                            {planCardItem.updateListItem.second.map((item) => {
                                                                return (
                                                                    <ListItem key={item.id}>
                                                                        <ListItemIcon>
                                                                            <CheckIcon sx={{ fill: '#fc7013' }} />
                                                                        </ListItemIcon>
                                                                        <ListItemText
                                                                            primary={
                                                                                <Typography variant="p" className="tier-description">
                                                                                    {item.text}
                                                                                </Typography>
                                                                            }
                                                                        />
                                                                    </ListItem>
                                                                );
                                                            })}
                                                        </List>
                                                    </CardContent>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        ) : null;
                    })
                ) : (
                    <UpdatePlanCardSkeleton />
                )}
            </Grid>
            <ReactivateModal
                open={open}
                handleClose={handleClose}
                planName={selectedPlan}
                paymentAmount={selectedTier}
                renewDate={userParsedData.endDate}
                newSelectedPlan={newSelectedPlan}
                newSelectedPriceId={newSelectedPriceId}
                onHandleClickUpdatePlan={onHandleClickUpdatePlan}
            />
        </>
    );
};
export default UpdatePricingCardItem;
